type SeoQueryKeyVars = {
    locationUrl: string;
};

export function getSeoQueryKey(vars: SeoQueryKeyVars) {
    return [{ scope: 'seo', ...vars }] as const;
}
